import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as OccupationDetailSelectors from './occupation-detail.selectors';
import * as OccupationDetailActions from './occupation-detail.actions';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OccupationDetailFacade {
  public occupationForExportPdf$ = this.store.select(
    OccupationDetailSelectors.selectOccupationForExportPdf
  );

  public occupationDetail$ = this.store.select(
    OccupationDetailSelectors.selectOccupationDetail
  );

  /** The last load that did not produce an occupation, keyed by page. */
  public occupationLoadFailure$ = this.store.select(
    OccupationDetailSelectors.selectOccupationLoadFailure
  );

  public showInstitutionsTab$ = this.occupationDetail$.pipe(
    map((x) => x?.showInstitutionPrograms)
  );

  constructor(private store: Store) {}

  public loadOccupationForExportPdf(): void {
    this.store.dispatch(OccupationDetailActions.loadOccupationForExportPdf());
  }

  public loadOccupationDetails(
    onetCode: string,
    jobId?: string,
    jobTitle?: string
  ): void {
    this.store.dispatch(
      OccupationDetailActions.loadOccupationDetail({
        onetCode,
        jobId,
        jobTitle
      })
    );
  }

  public clearOccupationDetail(): void {
    this.store.dispatch(OccupationDetailActions.clearOccupationDetail());
  }

  /** Clears only if the store still holds this page (see the action). */
  public clearOccupationDetailFor(onetCode: string, jobId?: string): void {
    this.store.dispatch(
      OccupationDetailActions.clearOccupationDetailFor({ onetCode, jobId })
    );
  }

  public clearOccupationForExportPdf(): void {
    this.store.dispatch(OccupationDetailActions.clearOccupationForExportPdf());
  }
}
